"use client"

import { X, Gift, CheckCircle2 } from "lucide-react"

export function PreReleaseModal({
  isOpen,
  onClose,
  onContinue,
}: { isOpen: boolean; onClose: () => void; onContinue: () => void }) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl max-w-md w-full transform transition-all duration-300 scale-100 shadow-2xl">
        <div className="bg-gradient-to-r from-red-700 to-orange-700 p-8 text-white relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 hover:bg-white/20 rounded-full transition-colors duration-200"
          >
            <X size={24} />
          </button>

          <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <Gift size={32} className="text-white" />
          </div>

          <h2 className="text-2xl font-bold text-center mb-2">Pre-Release Exclusive</h2>
          <p className="text-center text-orange-100 text-sm">Get Early Access Now</p>
        </div>

        <div className="p-8">
          <h3 className="text-xl font-bold text-gray-900 mb-4">The Shift Of Thrones</h3>

          <div className="space-y-4 mb-6">
            <div className="flex gap-3 items-start">
              <CheckCircle2 size={20} className="text-green-600 flex-shrink-0 mt-0.5" />
              <p className="text-gray-700">
                <span className="font-semibold">Limited Pre-Release Offer</span> - Discount price only available before the official
                launch
              </p>
            </div>

            <div className="flex gap-3 items-start">
              <CheckCircle2 size={20} className="text-green-600 flex-shrink-0 mt-0.5" />
              <p className="text-gray-700">
                <span className="font-semibold">Personally Signed</span> - Each copy will be hand-signed by Latangela
                Rogers
              </p>
            </div>

            <div className="flex gap-3 items-start">
              <CheckCircle2 size={20} className="text-green-600 flex-shrink-0 mt-0.5" />
              <p className="text-gray-700">
                <span className="font-semibold">Shipped Upon Release</span> - Your book will be sent to you as soon as
                it's published
              </p>
            </div>

            {/* <div className="flex gap-3 items-start">
              <CheckCircle2 size={20} className="text-green-600 flex-shrink-0 mt-0.5" />
              <p className="text-gray-700">
                <span className="font-semibold">Exclusive Access</span> - Be among the first to experience
                transformative insights
              </p>
            </div> */}
          </div>

          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-amber-900">
              <span className="font-semibold">Price:</span> $14.98 - This special pre-release price is available for a
              limited time only.
            </p>
          </div>

          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-3 border-2 border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors duration-300"
            >
              Cancel
            </button>
            <button
              onClick={onContinue}
              className="flex-1 px-4 py-3 bg-red-700 text-white rounded-lg font-medium hover:bg-red-800 transition-colors duration-300"
            >
              Continue to Purchase
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
